import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { qrBarcodeImageSrcGenerator } from '../templates/utils';
var useStyles = makeStyles(function (theme) { return ({
    barcodeImage: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}); });
export var QRBarcodeImage = function (props) {
    var classes = useStyles();
    if (!props.barcodeValue) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, { textAlign: 'center' },
        React.createElement("img", { className: classes.barcodeImage, alt: props.barcodeValue, src: qrBarcodeImageSrcGenerator({
                barcode: props,
                size: '10',
            }) })));
};
//# sourceMappingURL=QRBarcodeImage.js.map